<div class="forget-password-container">
  <form class="form_container" [formGroup]="forgetForm" (ngSubmit)="forgetPassword()">
    <button type="button" class="language-switcher-simple" mat-flat-button data-testid="switchLanguage" (click)="languageService.switchLanguage()">{{ 'menu.switchLanguage' | transloco }}</button>
    <div class="logo_container">
      <img alt="{{ 'header.title' | transloco }} Logo" src="assets/icons/android-chrome-192x192.png" />
    </div>
    <div class="title_container">
      <p class="title">{{ 'forgetPassword.title' | transloco }}</p>
    </div>
    <br>
      @if (submitError) {
        <div class="custom-error-alert">
          {{ 'forgetPassword.errorForm' | transloco  }}
        </div>
      }
      @if (resetSend) {
        <div class="custom-success-alert">
          {{ 'forgetPassword.resetSend' | transloco  }}
        </div>
      }
      <div class="input_container">
        <label class="input_label" for="email_field">{{ 'forgetPassword.email' | transloco }}</label>
        <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg" class="icon">
          <path stroke-linejoin="round" stroke-linecap="round" stroke-width="1.5" stroke="#141B34" d="M7 8.5L9.94202 10.2394C11.6572 11.2535 12.3428 11.2535 14.058 10.2394L17 8.5"></path>
          <path stroke-linejoin="round" stroke-width="1.5" stroke="#141B34" d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z"></path>
        </svg>
        <input formControlName="email" placeholder="name@mail.com" title="Email" name="email" type="text" class="input_field" id="email_field">
      </div>
      @if (forgetForm.get('email')?.invalid && forgetForm.get('email')?.touched) {
        <div class="error_message">
          {{ 'forgetPassword.requiredEmail' | transloco }}
        </div>
      }
      <button title="ForgetPassword" type="submit" class="forget_btn">
        <span>{{ 'forgetPassword.reset' | transloco }}</span>
      </button>
      <div class="login-container">
        <a (click)="login()" (keyup.enter)="login()" tabindex="0">{{ 'forgetPassword.login' | transloco  }}</a>
      </div>
      @if (resetSend) {
        <div class="custom-good-alert">
          {{ 'forgetPassword.errorForm' | transloco  }}
        </div>
      }
    </form>
  </div>
